import { getImageUrl } from '@/utils/images';
import { Background } from '../types';
import clsx from 'clsx';
import { getTailwindColor } from '@/utils/colors';

export const renderBackground = (background: Background) => {
    switch (background.type) {
        case 'image-wave':
            return (
                <>
                    <div className="r-absolute r-right-0 r-top-0 r-z-0 r-h-full r-w-1/2">
                        <img
                            src={getImageUrl(background.image?.src)}
                            alt={background.image?.alt}
                            className="r-h-full r-w-auto r-object-cover r-object-right"
                        />
                    </div>
                    <svg
                        className="r-absolute r-left-0 r-top-0 r-z-10 r-block r-h-full r-w-[60%]"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden
                    >
                        <path d="M0,0 L90,0 C100,25 100,75 90,100 L0,100 Z" fill={background.color?.color || 'white'} />
                    </svg>
                </>
            );
        case 'color-wave':
            return (
                <>
                    <div
                        className={clsx(
                            'r-absolute r-right-0 r-top-0 r-z-0 r-h-full r-w-1/2',
                            getTailwindColor(background.color?.key, 'bg') || 'r-bg-white'
                        )}
                    />
                    <svg
                        className="r-absolute r-left-0 r-top-0 r-z-10 r-block r-h-full r-w-[70%]"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden
                    >
                        <path d="M0,0 L90,0 C100,25 100,75 90,100 L0,100 Z" fill="white" />
                    </svg>
                </>
            );
        case 'solid':
        default:
            return <div className={clsx('r-absolute r-inset-0', getTailwindColor(background.color?.key, 'bg') || 'r-bg-white')} />;
    }
};
